import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { UserPatchType } from '@meniudigital/shared'
import Setting from '../Setting'

export default function WifiSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  const toggleVisibility = () => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.WifiInfo,
        data: { ...(user.wifiInfo || {}), isVisible: !user.wifiInfo?.isVisible },
      }),
    )
  }

  const updateNetworkName = (value: string) => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.WifiInfo,
        data: { ...(user.wifiInfo || {}), networkName: value },
      }),
    )
  }

  const updatePassword = (value: string) => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.WifiInfo,
        data: { ...(user.wifiInfo || {}), password: value },
      }),
    )
  }

  return (
    <Setting
      title="Rețeaua și Parola WiFi"
      iconPath="/icons/wifi.png"
      isEnabled={user.wifiInfo?.isVisible}
      onToggle={toggleVisibility}
      body={
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            type="text"
            placeholder="Nume rețea WiFi"
            defaultValue={user.wifiInfo?.networkName || ''}
            onBlur={e => updateNetworkName(e.target.value)}
          />
          <input
            type="text"
            placeholder="Parolă WiFi"
            defaultValue={user.wifiInfo?.password || ''}
            onBlur={e => updatePassword(e.target.value)}
          />
        </div>
      }
    />
  )
}
